<template>
  <layout-report-step
    :md="md"
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :showFooter="false"
  >
    <v-radio-group v-model="isCompany">
      <!-- Company -->
      <v-sheet :color="isCompany === true ? 'primary' : ''" outlined rounded class="mb-2 py-n6">
        <v-card flat @click="isCompany = true">
          <v-list>
            <v-list-item>
              <v-list-item-avatar tile size="60">
                <v-icon>mdi-office-building</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ $t("report.thgIsCompanyRequired.company") }} </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-radio :value="true" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-sheet>
      <!-- Privat -->
      <v-sheet :color="isCompany === false ? 'primary' : ''" outlined rounded class="mb-2 py-n6">
        <v-card flat @click="isCompany = false">
          <v-list>
            <v-list-item>
              <v-list-item-avatar tile size="60">
                <v-icon>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ $t("report.thgIsCompanyRequired.private") }} </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-radio :value="false" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-card-text v-if="!isCompany">
            {{ $t("report.thgIsCompanyRequired.privateInfo") }}
          </v-card-text>
          <v-card-actions v-if="!isCompany">
            <v-btn color="primary" @click="switchToWkthg"> {{ $t("report.thgIsCompanyRequired.privateBtn") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </v-radio-group>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ThgIsCompanyRequired extends ReportStepMixin implements IReportStep {
  md = 4;
  header: IReportHeaderData = {
    title: "report.thgIsCompanyRequired.title",
    description: "report.thgIsCompanyRequired.description"
  };

  screen = ReportScreenEnum.thgIsCompanyRequired;

  switchToWkthg() {
    window.open("https://app.wirkaufendeinethg.de/#/", "_blank");
  }

  get isCompany() {
    return ThgCreateModule.isCompany;
  }

  set isCompany(isCompany: boolean) {
    ThgCreateModule.setIsCompany(isCompany);
  }

  get isDone() {
    return !!this.isCompany;
  }

  get partnerId() {
    return ReportModule.partner.id || ReportModule.partner._id;
  }

  /**
   * Validate zip if it is already set e.g. from store
   */
  async mounted() {
    this.isCompany = true;
    this.setCurrentStep();
  }
}
</script>
